import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const hasNavPermission = (user, key) => {
  if (!user) return false;
  if (user.is_staff || user.is_superuser) return true;
  return !!user.nav_permissions?.[key];
};

// This permission is intentionally stricter than normal nav permissions:
// staff users do not get it implicitly, only superusers or an explicit grant.
export const canViewUserActivity = (user) =>
  !!user && (!!user.is_superuser || !!user.nav_permissions?.view_user_activity);

const ProtectedRoute = ({ children, requireAdmin = false, requirePermission = null }) => {
  const { user, loading } = useAuth();

  if (loading) return <div className="page-loader">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !(user.is_staff || user.is_superuser)) {
    return <Navigate to="/" replace />;
  }
  if (requirePermission) {
    const keys = Array.isArray(requirePermission) ? requirePermission : [requirePermission];
    if (!keys.some((key) => hasNavPermission(user, key))) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
